// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3aoC6","rootSmall":"AddTileButton_rootSmall__3pu1m"};